// Helper to prepend the public path (basename) to asset URLs
export const getPublicUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  // Use %PUBLIC_URL% for CRA or process.env.PUBLIC_URL for runtime
  return `${process.env.PUBLIC_URL || '/agencies/oto/fasttrack'}/${cleanPath}`;
}; 